import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Mail, Phone, MapPin } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function Footer() {
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    axios.get(`${API}/settings/public`).then((r) => setSettings(r.data)).catch(() => {});
  }, []);
  const contactEmail = settings?.contact_email || 'contact@cresa-asbl.org';
  const contactPhone = settings?.contact_phone || '+243 853 717 311';
  const contactPhone2 = settings?.contact_phone_2 || '+243 847 143 388';
  const contactAddress = settings?.contact_address || 'Avenue des Martyrs ex-VAMARO N°05, Bukavu, RD Congo';
  return (
    <footer className="bg-[#4A3728] text-white" data-testid="main-footer">
      <div className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="text-xl font-bold mb-4" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
              CRESA ASBL
            </h3>
            <p className="text-sm text-gray-300 leading-relaxed">
              Carrefour de Réflexion Santé - ASBL de droit congolais œuvrant pour le développement intégral auto-géré en RD Congo
            </p>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
              Navigation
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/projets" className="text-sm text-gray-300 hover:text-white transition-colors" data-testid="footer-link-projets">
                  Projets
                </Link>
              </li>
              <li>
                <Link to="/activites" className="text-sm text-gray-300 hover:text-white transition-colors" data-testid="footer-link-activites">
                  Activités
                </Link>
              </li>
              <li>
                <Link to="/videos" className="text-sm text-gray-300 hover:text-white transition-colors" data-testid="footer-link-videos">
                  Vidéos
                </Link>
              </li>
              <li>
                <Link to="/galerie" className="text-sm text-gray-300 hover:text-white transition-colors" data-testid="footer-link-gallery">
                  Galerie photos
                </Link>
              </li>
              <li>
                <Link to="/documents" className="text-sm text-gray-300 hover:text-white transition-colors" data-testid="footer-link-documents">
                  Documents & rapports
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-sm text-gray-300 hover:text-white transition-colors" data-testid="footer-link-blog">
                  Blog
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
              S&apos;engager
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/dons" className="text-sm text-gray-300 hover:text-white transition-colors" data-testid="footer-link-donations">
                  Faire un don
                </Link>
              </li>
              <li>
                <Link to="/register" className="text-sm text-gray-300 hover:text-white transition-colors" data-testid="footer-link-register">
                  Devenir membre
                </Link>
              </li>
              <li>
                <Link to="/calendrier" className="text-sm text-gray-300 hover:text-white transition-colors" data-testid="footer-link-calendar">
                  Calendrier
                </Link>
              </li>
              <li>
                <Link to="/recrutement" className="text-sm text-gray-300 hover:text-white transition-colors" data-testid="footer-link-jobs">
                  Recrutement
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
              Contact
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <MapPin size={18} className="mt-1 flex-shrink-0" />
                <span className="text-sm text-gray-300" data-testid="footer-address">
                  {contactAddress}
                </span>
              </li>
              <li className="flex items-center space-x-2">
                <Mail size={18} className="flex-shrink-0" />
                <a href={`mailto:${contactEmail}`} className="text-sm text-gray-300 hover:text-white transition-colors" data-testid="footer-email">
                  {contactEmail}
                </a>
              </li>
              <li className="flex items-center space-x-2">
                <Phone size={18} className="flex-shrink-0" />
                <a href={`tel:${contactPhone.replace(/\s/g, '')}`} className="text-sm text-gray-300 hover:text-white transition-colors" data-testid="footer-phone-1">
                  {contactPhone}
                </a>
              </li>
              {contactPhone2 && (
                <li className="flex items-center space-x-2">
                  <Phone size={18} className="flex-shrink-0" />
                  <a href={`tel:${contactPhone2.replace(/\s/g, '')}`} className="text-sm text-gray-300 hover:text-white transition-colors" data-testid="footer-phone-2">
                    {contactPhone2}
                  </a>
                </li>
              )}
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-600 mt-8 pt-8 text-center">
          <p className="text-sm text-gray-400">
            &copy; {new Date().getFullYear()} CRESA ASBL. Tous droits réservés. Les données partagées sur ce site demeurent la propriété exclusive de CRESA ASBL.
          </p>
          <p className="text-xs text-gray-500 mt-2">
            <Link to="/mentions-legales" className="text-gray-400 hover:text-white underline" data-testid="footer-link-legal">
              Mentions légales & propriété des données
            </Link>
          </p>
          <p className="text-xs text-gray-500 mt-2 italic">
            &ldquo;Réflexion sans actions est du verbiage et actions sans réflexion est une agitation.&rdquo;
          </p>
        </div>
      </div>
    </footer>
  );
}
